<template>
    <v-dialog
        v-model="isDialogOpen"
        width="1000"
    >
        <v-card>
            <v-toolbar
                flat
            >
                <v-toolbar-title class="pl-6">
                    <span class="font-weight-bold">{{ headerTitle }}</span>
                </v-toolbar-title>
                <v-toolbar-items class="pr-2 ml-auto">
                    <v-btn
                        icon
                        @click.native="$emit('close')"
                    >
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-container>
                <v-form
                    ref="form"
                    v-model="formValid"
                >
                    <v-row>
                        <v-col>
                            <v-autocomplete
                                v-model="editAttributeId"
                                :disabled="dialogType === 'add'"
                                :label="$t('selectAttribute')"
                                :items="attributes"
                                item-text="nameRu"
                                item-value="id"
                                @change="setInitialData"
                                color="teal lighten-2"
                                item-color="teal lighten-2"
                            ></v-autocomplete>
                        </v-col>
                        <v-col>
                            <v-autocomplete
                                v-model="formData.lvl"
                                :label="$t('attributeType')"
                                :items="attributeTypes"
                                color="teal lighten-2"
                                item-color="teal lighten-2"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field
                                v-model="formData.attributeNameRu"
                                :label="$t('nameRu')"
                                :rules="rules"
                                color="teal lighten-2"
                                item-color="teal lighten-2"
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field
                                v-model="formData.attributeNameUa"
                                :label="$t('nameUa')"
                                :rules="rules"
                                color="teal lighten-2"
                                item-color="teal lighten-2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-autocomplete
                                v-model="formData.categoryIDs"
                                :items="categories"
                                :label="$t('category')"
                                item-text="localName"
                                item-value="id"
                                hide-no-data
                                cache-items
                                clearable
                                multiple
                                color="teal lighten-2"
                                item-color="teal lighten-2"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
            <v-card-actions>
                <v-btn
                    depressed
                    class="white--text teal"
                    width="130"
                    :disabled="!formValid"
                    @click="validate"
                >{{$t('save')}}</v-btn>
                <v-btn
                    @click="$emit('close')"
                >{{ $t('cancel') }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn
                    v-if="dialogType === 'edit'"
                    :disabled="!editAttributeId"
                    @click="setDeleteAttribute"
                    outlined
                    color="error"
                >{{ $t('delete') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { MixinDialogRemote } from '../../mixins'
import { AttributesService, InfoService } from "../../services";

export default {
    name: "EnumAttributeDialog",
    mixins: [ MixinDialogRemote ],
    props: [ 'dialogType', 'initialAttribute' ],
    data() {
        return {
            editAttributeId: null,
            categories: [],
            attributes: [],
            attributeTypes: [1, 2],
            formData: {
                categoryIDs: [],
                attributeNameRu: null,
                attributeNameUa: null,
                lvl: null,
            },
            formValid: false,
            rules: [
                value => !!value || this.$t('requiredField')
            ],

        }
    },
    computed: {
        headerTitle() {
            return `${this.$t(this.dialogType)} ${this.$t('attribute')}`;
        }
    },
    methods: {
        setDeleteAttribute() {
            this.$emit('deleteAttribute', this.editAttributeId);
        },
        resetForm() {
            this.editAttributeId = null;
            this.formData = {
                categoryIDs: [],
                attributeNameRu: null,
                attributeNameUa: null,
                lvl: null,
            };
        },
        setCategories() {
            InfoService.setAuth(this.$store.getters.token);
            InfoService.getAttributesCategories()
                .then(res => {
                    this.categories = res.data;
                })
                .catch(err => {
                    console.log(err);
                })
        },
        setInitialData() {
            const attribute = this.attributes.find(item => {
                return item.id === this.editAttributeId;
            })

            this.formData = {
                lvl: attribute.lvl,
                attributeNameRu: attribute.nameRu,
                attributeNameUa: attribute.nameUa,
                categoryIDs: attribute.categoryIDs,
            }
        },
        validate() {
            if (this.$refs.form.validate()) {
                const params = {
                    actionType: this.dialogType,
                    attributeData: this.formData
                };
                if(this.dialogType === 'edit') { params.attributeData.id = this.editAttributeId }
                this.$emit('validated', params);
            }
        }
    },
    watch: {
        isDialogOpen(value) {
            if (value) {
                this.resetForm();
                this.setCategories()

                if(this.dialogType === 'edit') {
                    AttributesService.setAuth(this.$store.getters.token);
                    AttributesService.getAttributes()
                        .then(res => {
                            this.attributes = res.data;
                        })
                        .catch(err => {
                            console.log(err);
                        })
                }

            }
        },
    }
}
</script>

<style scoped>

</style>
